import React from "react";
import { Snackbar, Alert, Box } from "@mui/material";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";

const AlertMessage = ({ open, handleClose, message, severity }) => {
  const iconMapping = {
    error: <CancelIcon sx={{ color: "white" }} />,
    success: <CheckCircleIcon sx={{ color: "white" }} />,
    info: <InfoIcon sx={{ color: "white" }} />,
    warning: <WarningIcon sx={{ color: "white" }} />,
  };

  const snackbarBackgroundColor = (value) => {
    switch (value) {
      case "success":
        return "#21A945";
      case "error":
        return "#eb3e30";
      case "info":
        return "#2e86eb";
      case "warning":
        return "#ffa600";
      default:
        return "white";
    }
  };

  return (
    <Snackbar
      open={open}
      disableWindowBlurListener
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          backgroundColor: snackbarBackgroundColor(severity),
          borderRadius: "5px",
          color: "white",
          width: "714px",
          boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
          textAlign: "left",
        }}
      >
        <Alert
          variant="filled"
          severity={severity}
          sx={{
            color: "white",
            backgroundColor: snackbarBackgroundColor(severity),
          }}
          iconMapping={iconMapping}
        >
          {message}
        </Alert>
      </Box>
    </Snackbar>
  );
};

export default AlertMessage;
